import { Skeleton } from '@/components/ui/skeleton'

import type { FC } from 'react'

export const WorkspaceSummaryCardSkeleton: FC = () => {
	return (
		<div className="flex items-center gap-4 p-4 rounded-lg bg-card text-card-foreground shadow-sm">
			<Skeleton className="h-14 w-14 rounded-lg bg-muted" />
			<div className="flex-1">
				<Skeleton className="h-5 w-48 bg-muted" />
			</div>
			<div className="flex items-center gap-2">
				<Skeleton className="h-9 w-9 bg-muted" />
				<Skeleton className="h-9 w-9 bg-muted" />
				<Skeleton className="h-9 w-9 bg-muted" />
			</div>
		</div>
	)
}
